// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video_wrapper__WdDxJ","poster":"video_poster__eFkl_","hidden":"video_hidden__taqH_","player":"video_player__oEW3H","play":"video_play__Y7TTL"};